// extracted by css-extract-rspack-plugin
export default {"PromoSlot":"NavbarPromoSlot-module__PromoSlot___Jq7Fa"};